"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/esnext.map.delete-all.js";
import "core-js/modules/esnext.map.every.js";
import "core-js/modules/esnext.map.filter.js";
import "core-js/modules/esnext.map.find.js";
import "core-js/modules/esnext.map.find-key.js";
import "core-js/modules/esnext.map.includes.js";
import "core-js/modules/esnext.map.key-of.js";
import "core-js/modules/esnext.map.map-keys.js";
import "core-js/modules/esnext.map.map-values.js";
import "core-js/modules/esnext.map.merge.js";
import "core-js/modules/esnext.map.reduce.js";
import "core-js/modules/esnext.map.some.js";
import "core-js/modules/esnext.map.update.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useEffect, useRef, useState } from 'react';
const observers = new Map();
const getObserver = options => {
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      const callbackMap = observers.get(observer);
      if (callbackMap) {
        const callback = callbackMap.get(entry.target);
        if (callback) {
          callback(entry.isIntersecting);
        }
      }
    }
  }, options);
  observers.set(observer, new Map());
  return observer;
};
const useInView = (options, externalRef) => {
  const [isInView, setIsInView] = useState(false);
  const internalRef = useRef(null);
  const elementRef = externalRef || internalRef;
  useEffect(() => {
    if (!elementRef.current) {
      // @ts-ignore
      return;
    }
    const observer = getObserver(options);
    const callbackMap = observers.get(observer);
    if (callbackMap && elementRef.current) {
      callbackMap.set(elementRef.current, setIsInView);
      observer.observe(elementRef.current);
    }
    const cleanup = () => {
      if (elementRef.current && callbackMap) {
        observer.unobserve(elementRef.current);
        callbackMap.delete(elementRef.current);
        // Clean up observer if there are no more observed elements
        if (callbackMap.size === 0) {
          observer.disconnect();
          observers.delete(observer);
        }
      }
    };
    if (options !== null && options !== void 0 && options.stopObservingAfterIntersecting && isInView) {
      return cleanup();
    }
    return cleanup;
  }, [options, elementRef, isInView]);
  return _objectSpread({
    isInView,
    elementRef
  }, options);
};
export default useInView;